import * as React from 'react'
import ReactDatePicker from 'react-datepicker'
import Sizes from '../Input.sizes'
import { Input } from './Input.date.style'

export type InputDateElement = ReactDatePicker

export type InputDateRef = React.ForwardedRef<InputDateElement>

export interface InputDateProps {
    borderColor?: string | boolean
    maxDate?: Date
    minDate?: Date
    onChange?: (val: number) => any
    size?: Sizes
    value?: number
    withTime?: boolean
    style?: any
}

const InputDate = React.forwardRef((props: InputDateProps, ref: InputDateRef) => {
    const { borderColor = undefined, onChange = () => undefined, size = Sizes.MD, value = new Date().getTime(), withTime = false, ...rest } = props
    return (
        <Input
            ref={ref}
            borderColor={borderColor}
            dateFormat={withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
            onChange={(val: Date) => onChange(new Date(val).getTime())}
            selected={new Date(value)}
            showTimeSelect={withTime}
            size={size}
            timeCaption="Time"
            timeFormat="HH:mm"
            timeIntervals={15}
            {...rest}
        />
    )
})

export default InputDate
